module.exports = __webpack_public_path__ + "img/DTP-logo.53fd0a9b.png";